import { ClassNames } from "@emotion/react"
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock"
import { useContext } from "react"
import ReactModal from "react-modal"

import shadowRootContext from "./ShadowRootContext"

const closeTimeoutMS = 300

type Props = Omit<ReactModal.Props, "className"> & {
  className?: string
  children: React.ReactNode
}

const Modal = ({ onAfterOpen, onAfterClose, className, ...props }: Props) => {
  const shadowRoot = useContext(shadowRootContext)
  return (
    <ClassNames>
      {({ css, cx }) => {
        const styles = {
          portal: css`
            .ReactModal__Overlay--after-open {
              opacity: 1;
            }

            .ReactModal__Overlay--before-close {
              opacity: 0;
            }
          `,
          modal: css`
            min-width: 200px;
            max-width: 90%;
            min-height: 200px;
            max-height: 90%;
            padding: 20px;
            overflow: auto;
            background-color: #ffffff;
            outline: transparent;
          `,
          overlay: css`
            position: fixed;
            top: 0px;
            right: 0px;
            bottom: 0px;
            left: 0px;
            z-index: 10000; /** 静的サイト上部のナビバーのz-indexが9999となっているため10000としています。 */
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(51, 51, 51, 0.3);

            opacity: 0;
            transition: opacity ${closeTimeoutMS}ms ease-in-out;
          `,
        }
        return (
          <ReactModal
            {...props}
            onAfterOpen={(options) => {
              if (options?.contentEl) {
                disableBodyScroll(options.contentEl, { reserveScrollBarGap: true })
              }
              onAfterOpen?.()
            }}
            onAfterClose={() => {
              clearAllBodyScrollLocks()
              onAfterClose?.()
            }}
            closeTimeoutMS={closeTimeoutMS}
            className={cx(styles.modal, className)}
            portalClassName={styles.portal}
            overlayClassName={styles.overlay}
            parentSelector={() => (shadowRoot?.firstElementChild as HTMLElement) || document.body}
          />
        )
      }}
    </ClassNames>
  )
}

Modal.setAppElement = (appElement: string | HTMLElement) => {
  ReactModal.setAppElement(appElement)
}

export default Modal
